import { mix } from "@chorda/core";
export const withFieldIcons = (props) => {
    return mix({
        templates: {
            control: {
                css: 'control',
                templates: {
                    iconLeft: {
                        tag: 'span',
                        css: 'icon is-small is-left',
                        templates: {
                            content: {
                                classes: {
                                    'icon': false
                                }
                            }
                        },
                        reactions: {
                            leftIcon: (v) => ({
                                components: {
                                    content: v
                                }
                            })
                        }
                    },
                    iconRight: {
                        tag: 'span',
                        css: 'icon is-small is-right',
                        templates: {
                            content: {
                                classes: {
                                    'icon': false
                                }
                            }
                        },
                        reactions: {
                            rightIcon: (v) => ({
                                components: {
                                    content: v
                                }
                            })
                        }
                    },
                },
                reactions: {
                    leftIcon: (v) => ({
                        components: {
                            iconLeft: !!v
                        },
                        classes: {
                            'has-icons-left': !!v
                        }
                    }),
                    rightIcon: (v) => ({
                        components: {
                            iconRight: !!v
                        },
                        classes: {
                            'has-icons-right': !!v
                        }
                    }),
                }
            }
        }
    }, props);
};
export const FieldIcons = (props) => {
    return mix(withFieldIcons({
        injections: {
            leftIcon: () => props.leftIcon,
            rightIcon: () => props.rightIcon
        }
    }));
};
